import { Component, HostBinding } from '@angular/core';

@Component({
    // moduleId: module.id,
    selector: 'footer-cmp',
    templateUrl: 'footer.component.html',
    styleUrls: ['footer.component.scss'],
    standalone: false
})

export class FooterComponent {
    date: Date = new Date();
}
